// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 708 ? "aa923549" : chunkId) + "." + {"68":"efac5b994c354fcb","394":"301bc8d2bf6abd53","708":"b940448c8d65f20b"}[chunkId] + ".js";
};